import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  MenuItem, Autocomplete
} from "@mui/material";
import { FadeLoader } from "react-spinners";
import AppraisalViewController from "../../redux/actions/AppraisalAction";

function AppraisalReviewFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { getAppraisalCycle, addAppraisalReview,updateAppraisalReview} = AppraisalViewController();

  const { appraisal, isLoading } = useSelector((state) => state.apprisalcycle);
  
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    appraisal: "",
    rating: "",
    comments: "",
  });

  useEffect(() => {
    dispatch(getAppraisalCycle());

    if (show && initialData) {
      setInitialValues({
        appraisal: initialData.appraisal || "",
        rating: initialData.rating || "",
        comments: initialData.comments || "",
      });
    } else if (show) {
      setInitialValues({
        appraisal: "",
        rating: "",
        comments: "",
      });
    }
  }, [show, initialData, dispatch]);

  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updateAppraisalReview(initialData.id, values)
      : addAppraisalReview(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting review:", error);
      });
  };

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? "Edit Review" : "Add Review"}</DialogTitle>

      <DialogContent dividers>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, handleChange }) => (
            <Form>
              <Grid container spacing={2}>
                {/* Appraisal Dropdown */}
                <Grid item xs={12}>
                  <Autocomplete
    fullWidth
    options={appraisal || []}
    getOptionLabel={(option) =>
      `${option.employee_name} — ${option.cycle_start} to ${option.cycle_end}`
    }
    value={appraisal.find((app) => app.id === values.appraisal) || null}
    onChange={(e, newValue) => {
      if (newValue) {
        setFieldValue("appraisal", newValue.id);
      } else {
        setFieldValue("appraisal", "");
      }
    }}
    renderInput={(params) => (
      <TextField {...params} label="Appraisal" />
    )}
  />
                </Grid>

                {/* Rating */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="number"
                    step="0.01"
                    label="Rating"
                    name="rating"
                    value={values.rating}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Comments */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Comments"
                    name="comments"
                    value={values.comments}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Buttons */}
                <Grid item xs={12} textAlign="right">
                  <Button
                    variant="outlined"
                    onClick={handleClose}
                    sx={{ mr: 2 }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    {isEdit ? "Update" : "Submit"}
                  </Button>
                </Grid>
              </Grid>

              {isLoading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.6)",
                    zIndex: 9999,
                  }}
                >
                  <FadeLoader loading={true} size={150} />
                </div>
              )}
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

export default AppraisalReviewFormModal;
